import Breadcrumbs from "@/components/Breadcrumbs";
import Reveal from "@/components/Reveal";

/**
 * Dark editorial hero band for interior pages.
 */
export default function PageHero({ eyebrow, title, intro, breadcrumbs }) {
  return (
    <section className="relative bg-ink text-white overflow-hidden pt-32 sm:pt-36 pb-16 sm:pb-20">
      <div
        className="absolute inset-0 opacity-70"
        aria-hidden="true"
        style={{
          background:
            "radial-gradient(70% 90% at 85% 10%, rgba(244,204,215,0.10), transparent 60%), radial-gradient(60% 80% at 10% 90%, rgba(217,185,110,0.12), transparent 60%)",
        }}
      />
      <div className="container-x relative">
        {breadcrumbs && (
          <div className="mb-8">
            <Breadcrumbs items={breadcrumbs} dark />
          </div>
        )}
        {eyebrow && (
          <Reveal as="p" className="eyebrow text-blush mb-4">
            {eyebrow}
          </Reveal>
        )}
        <Reveal as="h1" className="text-4xl sm:text-5xl lg:text-6xl max-w-4xl text-white">
          {title}
        </Reveal>
        {intro && (
          <Reveal as="p" delay={0.1} className="mt-6 max-w-2xl text-base md:text-lg text-white/70 leading-relaxed">
            {intro}
          </Reveal>
        )}
        <span className="mt-8 block h-px w-16 bg-blush/70" aria-hidden="true" />
      </div>
    </section>
  );
}
